<div class="loader-container">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  <h1 *ngIf="!noText">Loading...</h1>
</div>
